module.exports = __webpack_public_path__ + "img/croisade.cc1347f8.png";